import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from '../../../../../core/models';
import { BaseApiService } from '../../../../../core/services/base-api.service';
import type {
  AchPaymentRequestApprovalDetailDTO,
  AchPaymentRequestApprovalListRequestDTO,
  AchPaymentRequestApprovalListResultDTO,
  AchPaymentRequestFileDTO,
  ResolveAchPaymentRequestDTO,
} from '../../models/approval-ach-receipts.model';
import type { ApprovalAchReceiptsRepository } from '../contracts/approval-ach-receipts.repository';

@Injectable({ providedIn: 'root' })
export class ApprovalAchReceiptsHttpRepository
  extends BaseApiService
  implements ApprovalAchReceiptsRepository
{
  private readonly controllerUrl = '/ACHPaymentRequestApproval/';

  list(
    request: AchPaymentRequestApprovalListRequestDTO,
  ): Observable<HttpResponse<ApiResponse<AchPaymentRequestApprovalListResultDTO>>> {
    return this.http.post<ApiResponse<AchPaymentRequestApprovalListResultDTO>>(
      `${this.baseUrl}${this.controllerUrl}list`,
      request,
      { observe: 'response' },
    );
  }

  details(
    id: string,
  ): Observable<HttpResponse<ApiResponse<AchPaymentRequestApprovalDetailDTO>>> {
    return this.http.get<ApiResponse<AchPaymentRequestApprovalDetailDTO>>(
      `${this.baseUrl}${this.controllerUrl}details/${encodeURIComponent(id)}`,
      { observe: 'response' },
    );
  }

  resolve(
    request: ResolveAchPaymentRequestDTO,
  ): Observable<HttpResponse<ApiResponse<boolean>>> {
    return this.http.post<ApiResponse<boolean>>(
      `${this.baseUrl}${this.controllerUrl}resolve`,
      request,
      { observe: 'response' },
    );
  }

  file(id: string): Observable<HttpResponse<ApiResponse<AchPaymentRequestFileDTO>>> {
    return this.http.get<ApiResponse<AchPaymentRequestFileDTO>>(
      `${this.baseUrl}${this.controllerUrl}file/${encodeURIComponent(id)}`,
      { observe: 'response' },
    );
  }
}
